import React, { useState, useCallback, useEffect } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, TableContainer } from "./styles";

import Table from "../../../../components/Table/templates/inscricoes";
import Controls from "../../../../components/Controls";
import Axios from "axios";
import { systemLogs } from "../../../../services/system_logs";
import CursosSelector from "../../../../components/Admin/CursosSelector";
import SurveySelector from "./SurveySelector";

const PesquisaFormsSite = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [curso, setCurso] = useState("");
  const [options, setOptions] = useState([]);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [idSurvey, setIdSurvey] = useState("");
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorio(false);

    try {
      const res = await producaov2.post("/admin/reports/survey-answers", {
        data_inicio: dataInicio,
        data_final: dataFinal,
        survey_id: idSurvey,
      });

      setRelatorio(res.data.url);
      setLoading(false);

      await systemLogs(
        "Relatorio",
        `Gerou o relatorio de respostas da pesquisa`
      );

      swal("Confirmado!", "Relatório gerado com sucesso", "success");

      window.open(res.data.url, "blank");
    } catch (error) {
      console.log(error);

      setLoading(false);

      if (!error.response) {
        return;
      }

      swal(`Algo deu errado`, `${error?.response?.data?.message || 'Houve um erro ao gerar o relatório'}`, "error");
    }
  }, [dataInicio, dataFinal, idSurvey]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <Header>Relatório de Pesquisa (Forms Site)</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecione a Pesquisa</p>
              <FormField>
                <SurveySelector selectedSurveyID={idSurvey} onChangeSelectedSurveyID={setIdSurvey} />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              {relatorio && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorio, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default PesquisaFormsSite;
